import { DateField, TextField, useTranslate } from "react-admin";
import {
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
  useFieldLabel,
} from "ra-friendsofbabba";
import React, { useMemo } from "react";

import MediaField from "./MediaField";
import { UserField } from "../../component/field";

const UserBreaksField = ({ disabled, ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const translate = useTranslate();
  const transaction = useMemo(
    () => props?.record?.transaction,
    [props?.record]
  );

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={fieldLabel(props?.source)}
        subTitle={fieldLabel(`${props?.source}.help`)}
      />
      <ReferenceListField
        {...props}
        perPage={10}
        addLabel={false}
        reference="user-breaks"
        target="substitutive_declaration_id"
        createLabel="ra.action.add"
        create={false}
        modify={!disabled && transaction?.state === "draft"}
        remove={!disabled && transaction?.state === "draft"}
        sorry={fieldLabel("user-breaks.sorry")}
      >
        <TextField source="id" label="#ID" />
        <UserField label={fieldLabel("user_id")} source="user.name" />
        <TextField
          label={fieldLabel("user_break_reason_id")}
          source="user_break_reason.name"
        />
        <DateField source="start" emptyText={translate("ra.na")} />
        <DateField source="end" />
        <LongTextField source="description" minWidth={300} />
        <MediaField source="media" />
      </ReferenceListField>
    </Group>
  );
};
export default UserBreaksField;
